import { store } from '../stores/store';

function replaceTemplateText(text: string): string {
	const values: Record<string, string> = {
		TotalAmount: store.accountStore.cartTotalAmount.toFixed(2),
	};

	return text.replace(/\{([^}]+)\}/g, (match: string, content: string) => {
		const trimmedContent = content.trim();
		if (trimmedContent.startsWith('CurrentDate')) {
			const offsetMatch = trimmedContent.match(/CurrentDate([+-]\d+)?/);
			if (offsetMatch) {
				const offset = offsetMatch[1] ? parseInt(offsetMatch[1]) : 0;
				const currentDate = new Date();
				currentDate.setDate(currentDate.getDate() + offset);

				return new Intl.DateTimeFormat(store.configStore.currentLanguage).format(currentDate);
			}
		}
		if (Object.prototype.hasOwnProperty.call(values, trimmedContent)) {
			return values[trimmedContent];
		}
		return match;
	});
}

export default replaceTemplateText;
